import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { api } from '@/services/api'
import { useAuthStore } from '@/store/authStore'
import { useToastStore } from '@/store/toastStore'

export function AuthCallback() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const addToast = useToastStore((state) => state.addToast)

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get('code')

      if (!code) {
        addToast('error', 'Authentication failed')
        navigate('/login')
        return
      }

      try {
        const response = await api.post('/auth/exchange-code', { code })
        const { access_token, refresh_token, user } = response.data
        useAuthStore.getState().setAuth(user, access_token, refresh_token)
        addToast('success', 'Welcome!')
        navigate('/dashboard')
      } catch {
        addToast('error', 'Authentication failed')
        navigate('/login')
      }
    }

    handleCallback()
  }, [searchParams, navigate, addToast])

  return (
    <div className="min-h-[calc(100vh-8rem)] flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        <p className="text-gray-600">Completing sign in...</p>
      </div>
    </div>
  )
}
